import React from "react";
import helpers from "@src/../js/helpers";
import useHeaderMenuStore from "@src/stores/HeaderMenuStore";

export function HeaderActionSearch({ settings, isMobile }) {

    const { section } = settings;

    const text_style = section.header_font_type;
    const openMenu = useHeaderMenuStore((state) => state.openMenu)
    settings.show_search_in_header = false;

    return (
        <>

            {settings.show_search_in_header && (section.header_search_bar_position_mobile === 'below_header' || !isMobile) && <div
                className={`header-action__link flex items-center antialiased [&>svg]:h-[28px] cursor-pointer`}
                onMouseEnter={() => openMenu("SEARCH", isMobile)}
                onClick={() => openMenu("SEARCH", isMobile)}
            >
                {section.show_text_no_icons_search && !isMobile ? (
                    <a className={`${text_style}`}>SEARCH</a>
                ) : (
                    <i className={`${settings.section.search_icon} w-[16px] h-[16px]`}></i>
                )}
            </div>}

        </>
    );
}
